import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from './Footer';

const MorselsPost = () => {
  useEffect(() => {
    document.title = "Using Web 2.5 Apps to Reroll and Parlay Your Way to Profitability";
    return () => { document.title = 'Alan was here.'; };
  }, []);

  return (
    <div className="post-page" data-testid="morsels-post">
      <header className="post-header">
        <Link to="/blog" className="back-button" data-testid="post-back-button">
          <ArrowLeft size={20} />
          <span>Back to Banter</span>
        </Link>
      </header>

      <main className="post-main">
        <article className="post-article">
          <p className="post-title-display" data-testid="morsels-title">Using Web 2.5 Apps to Reroll and Parlay Your Way to Profitability</p>
          <div className="post-hero-image">
            <img 
              src="/img/web25-venn.webp" 
              alt="web-2.5-morsels" 
              className="hero-img"
              loading="eager"
            />
            <p className="image-source">source: <a href="https://shellypalmer.com/2022/10/web-2-5/" target="_blank" rel="noopener noreferrer">https://shellypalmer.com/2022/10/web-2-5/</a></p>
          </div>
          <p className="post-subtitle">You don't have to be an eastern spy or have an MBA from Wharton to do big business. Here's a list of the best web 2.5 apps that call on the ability to start generating formal benefits immediately.</p>
          <div className="post-banner">
            <a href="https://rollercoin.com/?r=mictzryr" target="_blank" rel="noopener noreferrer">
              <img src="https://static.rollercoin.com/static/img/ref/gen2/w970h90.gif" alt="RollerCoin" className="banner-img" loading="lazy" />
            </a>
          </div>
          <p className="post-body-text">I have compiled a list of Web 2.5 apps in no particular order below.</p>
          <ul className="post-list">
            <li><a href="https://coin.onelink.me/ePJg/q3nycsyn" className="post-link" target="_blank" rel="noopener noreferrer">CoinApp</a></li>
            <li><a href="https://cointiply.mobi/lYWB0l" className="post-link" target="_blank" rel="noopener noreferrer">Cointiply</a></li>
            <li><a href="https://www.atlasearth.com/" className="post-link" target="_blank" rel="noopener noreferrer">Atlas Earth</a></li>
            <li><a href="https://rollercoin.com/?r=mictzryr" className="post-link" target="_blank" rel="noopener noreferrer">RollerCoin</a></li>
            <li><a href="https://limercoin.com/?ref=ja0injup" className="post-link" target="_blank" rel="noopener noreferrer">Limercoin</a></li>
            <li><a href="https://www.surveyjunkie.com/" className="post-link" target="_blank" rel="noopener noreferrer">Survey Junkie</a></li>
            <li><a href="https://stake.us/?c=22EFyOOR" className="post-link" target="_blank" rel="noopener noreferrer">Stake</a></li>
            <li><a href="https://www.getfitcash.com/" className="post-link" target="_blank" rel="noopener noreferrer">Fitcash</a></li>
            <li><a href="https://carvertise.com/drivers/" className="post-link" target="_blank" rel="noopener noreferrer">Carvertise</a></li>
          </ul>
          <div className="post-banner">
            <a href="https://limercoin.com/?ref=ja0injup" target="_blank" rel="noopener noreferrer">
              <img src="https://static.limercoin.com/promo/v1/dark/728x90.png" alt="Limercoin" width="728" height="90" className="banner-img" loading="lazy" />
            </a>
          </div>
        </article>
      </main>

      <Footer />

      <style jsx>{`
        .post-page {
          min-height: 100vh;
          background: #151312;
          padding: 24px;
        }

        .post-header {
          max-width: 800px;
          margin: 0 auto 40px;
        }

        .back-button {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: transparent;
          border: 1px solid rgba(182, 180, 189, 0.3);
          color: #998f8f;
          padding: 10px 16px;
          border-radius: 8px;
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          text-decoration: none;
          transition: all 0.2s ease;
        }

        .back-button:hover {
          border-color: #f46c38;
          color: #f46c38;
        }

        .post-main {
          max-width: 800px;
          margin: 0 auto;
        }

        .post-article {
          padding: 0;
        }

        .post-title-display {
          font-family: 'Poppins', sans-serif;
          font-size: clamp(28px, 5vw, 44px);
          font-weight: 700;
          color: #fff;
          line-height: 1.2;
          letter-spacing: -0.02em;
          margin: 0 0 24px 0;
        }

        .post-hero-image {
          margin: 0 0 32px 0;
          border-radius: 12px;
          overflow: hidden;
        }

        .hero-img {
          width: 100%;
          height: auto;
          display: block;
          border-radius: 12px;
        }

        .image-source {
          font-family: 'Poppins', sans-serif;
          font-size: 12px;
          color: #6a6b6e;
          margin: 8px 0 0 0;
          word-break: break-all;
        }

        .image-source a {
          color: #6a6b6e;
          text-decoration: none;
          transition: opacity 0.2s ease;
          word-break: break-all;
        }

        .image-source a:hover {
          opacity: 0.8;
        }

        .post-subtitle {
          font-family: 'Poppins', sans-serif;
          font-size: 18px;
          color: #998f8f;
          line-height: 1.7;
          margin: 0 0 32px 0;
        }

        .post-body-text {
          font-family: 'Poppins', sans-serif;
          font-size: 16px;
          color: #998f8f;
          line-height: 1.8;
          margin: 0 0 20px 0;
        }

        .post-list {
          list-style: disc;
          padding-left: 24px;
          margin: 0;
        }

        .post-list li {
          font-family: 'Poppins', sans-serif;
          font-size: 16px;
          color: #c4bfbf;
          line-height: 1.8;
          margin-bottom: 4px;
        }

        .post-link {
          color: #f46c38;
          text-decoration: none;
          border-bottom: 1px solid transparent;
          transition: border-color 0.2s ease;
        }

        .post-link:hover {
          border-bottom-color: #f46c38;
        }

        .post-banner {
          margin: 24px 0;
        }

        .banner-img {
          max-width: 100%;
          height: auto;
          border-radius: 8px;
          display: block;
        }

        @media (max-width: 768px) {
          .post-page {
            padding: 20px;
          }

          .post-subtitle {
            font-size: 16px;
          }

          .post-body-text {
            font-size: 15px;
          }

          .post-list li {
            font-size: 15px;
          }
        }

        @media (max-width: 600px) {
          .post-page {
            padding: 16px;
          }

          .post-subtitle {
            font-size: 15px;
          }

          .post-list {
            padding-left: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default MorselsPost;
